<app-race-details *ngIf="viewSelectionBlock" [selectedMeeting]="selectedMeeting"></app-race-details>

<div *ngIf="!viewSelectionBlock" class="container mt-2 pb-4">
  
  <div class="row">
    <div (click)="open_player()" class="live btn mb-2">{{'COMMON.WATCH-LIVE-STREAM' | translate}}</div>


    <div *ngFor="let item of meeting_data" class="betting-category mb-2">
      <div class="card-body px-0">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <span class="t">{{item.eventLabel}}</span>
            <span class="t-faded t-smaller">{{item.eventName}}</span>
          </div>
          <div class="extra d-flex">
            <div class="d-flex flex-column align-items-end">
              <span class="t-strong">{{item.eventTime.substr(0,5)}}</span>
              <span class="t-faded t-smaller">{{item.eventLocalDate}}</span>
            </div>
            <a (click)="viewRaceDetails(item)" class="btn btn-tertiary icon ml-2">
              <span class="icon icon-arrow-right"></span>
            </a>
            <!-- <a href="#" data-toggle="modal" data-target="#raceInfoModal" class="btn btn-tertiary icon ml-2">
              <span class="icon icon-info"></span>
            </a> -->
          </div>
        </div>
      </div>
    </div>

    


    <!-- <app-next-ten-odds  [selectedBetCategory]="selectedBetCategory"></app-next-ten-odds> -->


    <div *ngFor="let item of all_data " class="race-preview shadow p-0 mb-2">
      <div class="race-header bg-fill-secondary text-white">
        <div class="race-info">
          <div class="race-name text-uppercase">{{item.eventName}}</div>
          <div class="race-description text-uppercase">{{'COMMON.GAME' | translate}}: {{item.eventCode}}</div>
        </div>
        <div class="race-extra">
          {{item.eventTimeUTC.substr(11,5)}}
          <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
        </div>
      </div>


      <div class="race-content">
        <table class="racing-table table-borderless table-striped">
          <!-- <colgroup>
              <col width="10%"></col>
              <col width="10%"></col>
              <col width="50%"></col>
              <col width="10%"></col>
              <col width="20%"></col>
            </colgroup> -->
          <thead>
            <tr>
              <th class="text-center">P</th>
              <th>N</th>
              <th class="text-left">Selection</th>
              <th>Win</th>
              <th>Place</th>
            </tr>
          </thead>
          <tbody>

            <tr class="won">
              <td class="text-center">1</td>
              <td>{{item.eventPositions[0].selectionNumber}}</td>
              <td class="text-left">{{item.eventPositions[0].selectionName}}</td>
              <td>{{item.eventPositions[0].winAmount}}</td>
              <td>{{item.eventPositions[0].placeAmount}}</td>
            </tr>

            <tr class="">
              <td class="text-center">2</td>
              <td>{{item.eventPositions[1].selectionNumber}}</td>
              <td class="text-left">{{item.eventPositions[1].selectionName}}</td>
              <td>{{item.eventPositions[1].winAmount}}</td>
              <td>{{item.eventPositions[1].placeAmount}}</td>
            </tr>

            <tr class="">
              <td class="text-center">3</td>
              <td>{{item.eventPositions[2].selectionNumber}}</td>
              <td class="text-left">{{item.eventPositions[2].selectionName}}</td>
              <td>{{item.eventPositions[2].winAmount}}</td>
              <td>{{item.eventPositions[2].placeAmount}}</td>
            </tr>

            <tr class="">
              <td class="text-center">4</td>
              <td>{{item.eventPositions[3].selectionNumber}}</td>
              <td class="text-left">{{item.eventPositions[3].selectionName}}</td>
              <td>{{item.eventPositions[3].winAmount}}</td>
              <td>{{item.eventPositions[3].placeAmount}}</td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="race-footer">
        <div class="d-flex">
          <div class="d-flex flex-fill flex-column text-left">
            <span class="t-faded t-small C_BK">Quinella:</span>
            <span class="t">{{item.qn}}</span>
          </div>
          <div class="d-flex flex-fill flex-column text-center">
            <span class="t-faded t-small C_BK">Exacta:</span>
            <span class="t">{{item.csf}}</span>
          </div>
          <div class="d-flex flex-fill flex-column text-right">
            <span class="t-faded t-small C_BK">Trifecta:</span>
            <span class="t">{{item.tc}}</span>
          </div>
        </div>

        <br>

        <div class="d-flex">
          <div class="d-flex flex-fill flex-column text-left">
            <span class="t-faded t-small C_BK">F4:</span>
            <span class="t">{{item.f4}}</span>
          </div>
          <div class="d-flex flex-fill flex-column text-right">
            <span class="t-faded t-small C_BK">Off Time:</span>
            <span class="t">{{item.offTime}}</span>
          </div>
        </div>

      </div>
    </div>



 


    </div>
    </div>